const wasteBtns = document.querySelectorAll(".js-waste-btn");
const wasteOverlay = document.querySelector(".js-waste-overlay");
const wasteOverlayClose = document.querySelector(".js-waste-close");
const wasteVideo = document.querySelector(".js-waste-video");

if (typeof wasteOverlay != "undefined" && wasteOverlay != null) {

    wasteBtns.forEach((btn) => {
        const src = btn.dataset.src;
        
        btn.addEventListener("click", () => {
            body.classList.add("stop-scrolling");
            gsap.to(wasteOverlay, {
                autoAlpha: 1,
                y: 0,
                duration: 0.3,
                ease: "power2.inOut"
            });
            wasteVideo.setAttribute('src', src);
        });
    })

   

    wasteOverlayClose.addEventListener("click", () => {
        body.classList.remove("stop-scrolling");

        gsap.to(wasteOverlay, {
            autoAlpha: 0,
            duration: 0.3,
            y: "100%",
            ease: "power2.inOut"
        });
        wasteVideo.removeAttribute('data-src');

    });
}
